type AppSpacerPropsType = {
  space?: string;
  className?: string;
  isHorizontal?: boolean;
};

export const AppSpacer = (props: AppSpacerPropsType) => {
  const { space = "15px", className = "", isHorizontal = false } = props;
  return (
    <div
      className={`${className} app-spacer d-flex align-items-center justify-content-center`}
      style={{ [isHorizontal ? "width" : "height"]: space }}
      data-test="app-spacer"
      data-testid="app-spacer"
    ></div>
  );
};

export default AppSpacer;
